import { CheckCircle2, Circle, Clock, Edit3, Lock, Send } from "lucide-react";
import { cn } from "@/lib/utils";

type CardStatus =
  | "neinceput"
  | "in-lucru"
  | "finalizat"
  | "transmis"
  | "in-asteptare"
  | "primita"
  | "blocat"
  | "in-curand";

type StatusConfig = {
  label: string;
  icon: typeof Edit3;
  iconBg: string;
  iconColor: string;
};

const CARD_STATUS: Record<CardStatus, StatusConfig> = {
  neinceput: {
    label: "Neinceput",
    icon: Circle,
    iconBg: "bg-ds-surface-100",
    iconColor: "text-ds-text-500",
  },
  "in-lucru": {
    label: "În lucru",
    icon: Edit3,
    iconBg: "bg-ds-amber-100",
    iconColor: "text-amber-600",
  },
  finalizat: {
    label: "Finalizat",
    icon: CheckCircle2,
    iconBg: "bg-ds-green-100",
    iconColor: "text-green-600",
  },
  transmis: {
    label: "Transmis",
    icon: Send,
    iconBg: "bg-ds-blue-100",
    iconColor: "text-ds-blue-600",
  },
  "in-asteptare": {
    label: "În așteptare",
    icon: Clock,
    iconBg: "bg-ds-surface-100",
    iconColor: "text-ds-text-600",
  },
  primita: {
    label: "Primită",
    icon: CheckCircle2,
    iconBg: "bg-ds-emerald-100",
    iconColor: "text-emerald-600",
  },
  blocat: {
    label: "Blocat",
    icon: Lock,
    iconBg: "bg-ds-border-200",
    iconColor: "text-ds-text-500",
  },
  "in-curand": {
    label: "În curând",
    icon: Clock,
    iconBg: "bg-ds-surface-100",
    iconColor: "text-ds-text-400",
  },
};

type StatusBadgeProps = {
  status: CardStatus;
  compact?: boolean;
};

export function StatusBadge({ status, compact = false }: StatusBadgeProps) {
  const config = CARD_STATUS[status];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <span
      data-testid="status-badge"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium font-mono",
        compact ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-ds-xxs md:text-sm",
        config.iconBg,
        config.iconColor
      )}
    >
      <Icon size={compact ? 12 : 14} />
      {config.label}
    </span>
  );
}

export type { CardStatus };
